import { Route, Routes } from 'react-router-dom';

import type { MenuParserData } from '../../../types/menus';
import DefaultMenuHomeRouteMobile from './DefaultMenuHomeRouteMobile';
import DefaultMenuProfileRouteMobile from './DefaultMenuProfileRouteMobile';
import DefaultMenuSearchRouteMobile from './DefaultMenuSearchRouteMobile';
import DefaultMenuSubRouteMobile from './DefaultMenuSubRouteMobile';

type Props = {
  onCloseMenu(): void;
  searchInstanceRenderer?: MenuParserData['searchInstanceRenderer'];
};

const DefaultMenuMobileRoutes = (props: Props) => {
  const { searchInstanceRenderer, onCloseMenu } = props;

  return (
    <Routes>
      <Route path="/profile" element={<DefaultMenuProfileRouteMobile onCloseMenu={onCloseMenu} />} />
      <Route path="/home" element={<DefaultMenuHomeRouteMobile onCloseMenu={onCloseMenu} />} />
      <Route
        path="/search"
        element={
          <DefaultMenuSearchRouteMobile
            searchInstanceRenderer={searchInstanceRenderer}
            onCloseMenu={onCloseMenu}
          />
        }
      />
      <Route path="/:category/:id" element={<DefaultMenuSubRouteMobile onCloseMenu={onCloseMenu} />} />
    </Routes>
  );
};

export default DefaultMenuMobileRoutes;
